import { environment as defaultEnvironment } from "./environment";

export const environmentConfigLoader = new Promise<any>((resolve) => {
  const xmlhttp = new XMLHttpRequest();
  const method = "GET";
  const url = "./assets/config/config.json";
  xmlhttp.open(method, url, true);
  xmlhttp.onload = () => {
    if (xmlhttp.status === 200) {
      resolve(JSON.parse(xmlhttp.responseText));
    } else {
      resolve(defaultEnvironment.config);
    }
  };
  xmlhttp.send();
});
